import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "../../../app/store";

export const enum FormName {
    CREATE_BOT,
    UPDATE_BOT,
    CREATE_LOCATION,
    UPDATE_LOCATION,
    CREATE_FRANCHISE,
    UPDATE_FRANCHISE,
    CONNECT_INTEGRATION,
    UPDATE_INTEGRATION,
    CREATE_OFFER,
    UPDATE_OFFER,
    KNOWLEDGE_DEFINITION,
}


export interface ModalState {
    isFormOpen: boolean
    isAnimationFinished: boolean
    openedModal?: FormName
    formProps: Record<string, any>
}

const initialState: ModalState = {
    isFormOpen: false,
    isAnimationFinished: true,
    formProps: {}
};


export const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        openForm: (state, {payload}: PayloadAction<{ name: FormName, formProps?: Record<string, any> }>) => {
            state.isFormOpen = true
            state.isAnimationFinished = true
            state.openedModal = payload.name
            if (payload.formProps) {
                state.formProps = payload.formProps
            }
        },
        closeForm: (state) => {
            state.isFormOpen = false
            state.isAnimationFinished = false
            state.formProps = {}
        },
        endAnimation: (state) => {
            state.isAnimationFinished = true
        },
    },
    extraReducers: (builder) => {
    },
});

export const {
    openForm,
    closeForm,
    endAnimation
} = formSlice.actions;

export const formPropsSelector = (state: RootState): any => state.form.formProps;
export const isFormOpenSelector = (state: RootState): boolean => state.form.isFormOpen;
export const openedFormSelector = (state: RootState): FormName | undefined => state.form.openedModal;
export const isAnimationFinishedSelector = (state: RootState): boolean => state.form.isAnimationFinished;
